import { ADMIN_DASHBOARD_COPY } from '@sonar-software/sonar-ts-constants';
import { Customer } from '@sonar-software/sonar-core';
import { CustomerViewExtraDropdown } from './CustomerViewExtraDropdown';
import React from 'react';
import { Tooltip } from 'antd';

export interface CustomerViewExtraProps {
	id?: string;
	customer?: Customer | null;
	shardName?: string;
}

export const CustomerViewExtra: React.FC<CustomerViewExtraProps> = (props) => {
	const { id, customer, shardName } = props;

	return customer ?
		<div
			className='customer-view-extra'
			id={ id }>
			<Tooltip title={ ADMIN_DASHBOARD_COPY.METRIC_TOOLTIP_GLOBAL_KEY }>
				<span className='customer-view-extra-metric'>{ customer?.globalKey }</span>
			</Tooltip>
			<Tooltip title={ ADMIN_DASHBOARD_COPY.METRIC_TOOLTIP_LOCAL_KEY }>
				<span className='customer-view-extra-metric'>{ customer?.id }</span>
			</Tooltip>
			<Tooltip title={ ADMIN_DASHBOARD_COPY.METRIC_TOOLTIP_SHARD }>
				<span className='customer-view-extra-metric'>
					{ shardName ?? ADMIN_DASHBOARD_COPY.SHARD_NAME_NONE }
				</span>
			</Tooltip>
			<CustomerViewExtraDropdown
				customer={ customer }
				shardName={ shardName } />
		</div> :
	 null;
};

